import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../../Icon";
import Button from "../../../Button";
import style from "./style.module.scss";
export default function SelectInput(props) {
    const { options, placeholder = "Please Select", onEdit } = props;
    function editOptions(event) {
        if (onEdit) {
            onEdit();
        }
        event.stopPropagation();
    }
    let inputValue = placeholder;
    if (options.length > 3) {
        inputValue = `${options[0].label}, ${options[1].label} & ${options.length - 2} others`;
    }
    else if (options.length === 3) {
        inputValue = `${options[0].label}, ${options[1].label}, ${options[2].label}`;
    }
    else if (options.length === 2) {
        inputValue = `${options[0].label}, ${options[1].label}`;
    }
    else if (options[0]) {
        inputValue = options[0].label;
    }
    return (_jsxs(Button, { variation: "none", className: style["select-input"], onClick: editOptions, children: [inputValue, _jsx(Icon, { name: "caret--thin--down" })] }));
}
